import React from 'react'
import Btn from 'components/Btn'
import { withTranslation } from 'react-i18next'
// import { UilMoneyWithdrawal } from '@iconscout/react-unicons'
import { useDispatch } from 'react-redux'
import { previewModal } from 'store/slices/miscSlice'
import CreditModal from './CreditModal'
import { BsPlus } from "react-icons/bs";
import useSWR from 'swr'

export default withTranslation()(function Header({ t, closeForm }) {
  const dispatch = useDispatch()
  const { data } = useSWR('accounts/balances')

  return (
    <div className="w-full flex bg-white p-4 md:p-10 flex-col lg:flex-row mb-10 rounded-xl">
      <div className="w-full mb-7 md:mb-0 grow">
        <div className="md:mr-16">
          <h4 className="text-lg  md:text-2xl text-[#05213D] font-[700]">NGN  {data?.data?.find(x => x.type === 'credit').balance}</h4>
          <p className="text-sm">{t('credit.credit_balance')}</p>
        </div>
      </div>


      <div className="w-full md:w-44 h-12 overflow-hidden rounded-lg bg-primary  opacity-[0]">
        <Btn
          className="w-full md:w-44 h-12"
          content={() => <span className="flex items-center text-white"><BsPlus size={25} className="-ml-3 mr-2" /> {t('credit.add')}</span>}
          click={(event, rowData) => {
            dispatch(previewModal({
              title: `${t('credit.modal_title')}`,
              content: () => <CreditModal />
            }))
          }
          }
        />
      </div>
    </div>
  )
})